import { MutationCache, QueryCache, QueryClient } from '@tanstack/query-core'
import { logReactQueryFailure } from 'src/queries/queryDiagnostics'

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      logReactQueryFailure('query', error, query.queryKey)
    },
  }),
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      logReactQueryFailure('mutation', error, mutation.options.mutationKey)
    },
  }),
  defaultOptions: {
    queries: {
      /**
       * if the user goes to another tab, or looks at a different app and comes back,
       * we don't want to re-fetch the active queries
       */
      refetchOnWindowFocus: false,
      /**
       * if the query is mounted again, i.e. multiple components on the same page using the
       * same query, we don't want to re-fetch the query if it already has data
       * this is particularly useful when we have multiple components that need to use the same query,
       * this default setting makes it so that they don't each need to make requests separately,
       * and can share the single initial network request
       */
      refetchOnMount: (query): boolean => query.observers.length <= 1,
      /**
       * we don't want to automatically retry errored queries,
       * and need to implement a way for the user to take action
       */
      retryOnMount: false,
    },
  },
})
